import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = { loadingText: String }

  connect() {
    this.originalText = this.buttonTarget.value
    this.isSubmitting = false
  }

  submit(event) {
    // Prevent multiple submissions
    if (this.isSubmitting) {
      event.preventDefault()
      return
    }

    this.isSubmitting = true
    
    // Change button text and disable
    this.buttonTarget.value = this.loadingTextValue || "Loading..."
    this.buttonTarget.disabled = true
    
    // Reset on turbo events (success or error)
    document.addEventListener('turbo:submit-end', this.reset.bind(this), { once: true })
  }

  reset() {
    this.isSubmitting = false
    this.buttonTarget.disabled = false
    this.buttonTarget.value = this.originalText
  }
}